import { Component, Prop, Vue } from 'vue-property-decorator';
import defaultAvatar from '@/assets/images/defaultAvatar.png';

@Component
export default class Avatar extends Vue {
  @Prop() kmsid: number;
  @Prop() src: string;
  @Prop() badgeIcon: string;
  @Prop() badgeColor: string;
  @Prop({ default: 'bottom' }) placementBadge: string;

  private readonly placement = {
    top: 'top',
    bottom: 'bottom'
  };

  private badge = {
    default: 'default'
  };

  get colorStatus(): string {
    if (!this.isBottomPlacement) {
      return 'primary';
    }
    if (this.badgeColor) {
      return this.badgeColor;
    } else {
      return '';
    }
  }

  get badgeIconSource(): string {
    if (!this.isBottomPlacement) {
      return 'mdi-brightness-1';
    }
    if (this.badgeIcon) {
      return this.badgeIcon;
    } else {
      return this.badge.default;
    }
  }

  get imageSource(): string {
    if (this.src || this.kmsid) {
      return this.src || this.changeKmsIdToAvatarUrl(this.kmsid);
    } else {
      return defaultAvatar;
    }
  }

  get haveDefaultSlot(): boolean {
    return !!this.$slots.default;
  }

  get isBottomPlacement(): boolean {
    return this.placementBadge === this.placement.bottom;
  }

  get badgeSize(): number {
    if (this.isBottomPlacement) {
      return 12;
    }
    return 8;
  }

  get badgeOffset(): number {
    if (this.isBottomPlacement) {
      return 10;
    }
    return 8;
  }

  changeKmsIdToAvatarUrl(kmsid: number): string {
    return `https://hr.kms-technology.com/api/employees/photo/${kmsid}/320`;
  }
}
